import { call, put } from 'redux-saga/effects'
import { getHiringTeamMemberProfiles } from '../apiModules/hiringTeamMemberProfiles'
import { memberProfileEntities } from '../reducks'

export function* fetchHiringTeamMemberProfileEntitiesSaga(hiringTeamId, params) {
  const response = yield call(getHiringTeamMemberProfiles, hiringTeamId, params)

  if (response.result.length > 0) {
    yield put(memberProfileEntities.addCollection(response.result))
  }

  return response
}
